import { Auth } from 'aws-amplify';
import axios from 'axios';
import { key } from 'key-api';
import { loggerInfo } from 'utils/infoLog';

export const api = axios.create({
	baseURL: import.meta.env.VITE_BASE_API,
	headers: {
		'Content-type': 'application/json',
		'x-api-key': key,
	},
});

api.interceptors.request.use(async (config: any) => {
	try {
		Auth.configure({
			storage: sessionStorage,
		});
		const currentSession = await Auth.currentSession();
		config.headers.Authorization = `Bearer ${currentSession
			.getIdToken()
			.getJwtToken()}`;
	} catch (error) {
		loggerInfo({
			data: error,
			context: 'app',
			location: 'apiInterceptorsRequestUse',
		});
	}
	return config;
});

api.interceptors.response.use(
	(response) => {
		return response;
	},
	async function (error) {
		const originalRequest = error.config;
		if (
			error &&
			error.response &&
			error.response.status === 403 &&
			!originalRequest._retry
		) {
			try {
				originalRequest._retry = true;
				const token = await refreshAccessToken();
				axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
				return api(originalRequest);
			} catch (e) {
				console.error('Unable to refresh Token', e);
			}
		}
		return Promise.reject(error);
	},
);

const refreshAccessToken = async () => {
	Auth.configure({
		storage: sessionStorage,
	});
	const user = await Auth.currentAuthenticatedUser();
	const currentSession = await Auth.currentSession();
	user.refreshSession(
		currentSession.getRefreshToken(),
		(error: any, session: any) => {
			if (error) {
				throw error;
			}
			const { accessToken } = session;
			return accessToken.getJwtToken();
		},
	);
};

type refreshAccessTokenSetLocalStorageProp = {
	onChangeLocalStorageToken: (jwtToken: string) => void;
};

export const refreshAccessTokenSetLocalStorage = async ({
	onChangeLocalStorageToken,
}: refreshAccessTokenSetLocalStorageProp) => {
	Auth.configure({
		storage: sessionStorage,
	});
	const user = await Auth.currentAuthenticatedUser();
	const currentSession = await Auth.currentSession();
	return new Promise((resolve, reject) => {
		user.refreshSession(
			currentSession.getRefreshToken(),
			(error: any, session: any) => {
				if (error) {
					reject(error);
				}
				const jwtToken = session?.getIdToken()?.getJwtToken();
				onChangeLocalStorageToken(jwtToken);
				resolve(jwtToken);
			},
		);
	});
};
